var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_3169)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1641 91.4286C118.891 91.4286 134.878 75.4408 134.878 55.7143C134.878 35.9877 118.891 20 99.1641 20C79.4375 20 63.4498 35.9877 63.4498 55.7143C63.4498 75.4408 79.4375 91.4286 99.1641 91.4286ZM124.164 100.357H119.504C113.31 103.203 106.419 104.821 99.1641 104.821C91.9096 104.821 85.0458 103.203 78.8237 100.357H74.1641C53.4609 100.357 36.6641 117.154 36.6641 137.857V149.464C36.6641 156.858 42.6629 162.857 50.0569 162.857H148.271C155.665 162.857 161.664 156.858 161.664 149.464V137.857C161.664 117.154 144.867 100.357 124.164 100.357Z",
    fill: "#717783"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_3169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPage);
export default __webpack_public_path__ + "static/media/avatar-page.6a8dcfa383cbdd2a8270020bc7cdcb8b.svg";
export { ForwardRef as ReactComponent };